import React from "react";

import classNames from "classnames";

import styles from '../contentcards.module.scss';

export function ContentCardClassic({ data, onClick }) {

    return (
        <>
            <div className= { classNames(styles.classicCard) } onClick={onClick}>
                <div className= { classNames(styles.classicCardImage) }>
                    {data.imageUrl && !data.url && (<img	src={`${data.imageUrl}`} alt={data.title} width={60} height={60} />)}
                    {data.imageUrl && data.url && (<a target="_blank" href={data.url}><img	src={`${data.imageUrl}`} alt={data.title} width={60} height={60} /></a>)}
                </div>
                <div>
                    {data.title && (<h2 className={ classNames(styles.cardHeader) }>{data.title}</h2>)}
                    {data.description && (<p className={ classNames(styles.cardDescription) }>{data.description}</p>)}
                    {data.url && data.linkText && (<div className={ classNames(styles.cardLinkClassic) }><a target="_blank" href={data.url}>{data.linkText}</a></div>)}
                </div>
            </div>
        </>
    );
}